// 背包公共操作方法（pocket.vue / sortPocket.vue 共用）
import {postRequest, postJson, onResult} from '../../utils/api'
import Message from 'element-ui/lib/message'
import {effectLinesOf} from '../../utils/itemEffect'
export default {
  methods: {
    // 读取当前玩家体力：确认框要把「可恢复 X」换算成「当前 → 使用后」
    currentUserDetail() {
      try {
        const store = this.$store;
        if (store && store.state && store.state.user && store.state.user.fantasyUserDetail) {
          return store.state.user.fantasyUserDetail;
        }
      } catch (e) {
        // 无 Vuex 场景（单测/独立预览）忽略
      }
      return {};
    },
    // 使用确认框文案：带效果行（体力 + 限时增益），玩家点「使用」前就知道会发生什么
    // 口径与道具卡片一致（utils/itemEffect.js），避免两处文案打架
    useConfirmMessage(item) {
      const name = (item && item.itemName) || '道具';
      const lines = effectLinesOf(item, this.currentUserDetail());
      if (lines.length === 0) {
        return '您确定要使用【' + name + '】吗?';
      }
      const full = lines.some(function (l) { return l.indexOf('无需服用') > -1; });
      if (full) {
        return lines.join('\n') + '\n仍要使用【' + name + '】吗?';
      }
      return '确定使用【' + name + '】吗?\n' + lines.join('\n');
    },
    //删除道具
    delItem(itemId, index) {
      let _this = this;
      this.$confirm('您确定要删除道具吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        postRequest('/item/item/deleteItem', {
          itemId: itemId
        }).then(resp=> {
          onResult(resp, {
            success: data => {
              _this.myPocketItems = data.data;
              Message.success("道具删除成功");
            }
          });
        });
      }, function () {
        //取消
      })
    },
    // 堆叠道具
    stackItems() {
      let _this = this;
      _this.loading = true;
      postRequest('/item/item/stackItem', {
        cabinetId: 0
      }).then(resp=> {
        _this.loading = false;
        onResult(resp, {
          success: data => {
            Message.success("堆叠成功");
            _this.myPocketItems = data.data;
          }
        });
      }, resp=> {
        _this.loading = false;
      });
    },
    //拆分道具
    splitItem(itemId, index) {
      let _this = this;
      this.$prompt('请输入想要拆分的个数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[1-9]\d*/,
        inputErrorMessage: '请输入数字'
      }).then(({ value }) => {
        _this.loading = true;
        postJson('/item/item/splitItem', {
          cabinetId: 0,
          itemId: itemId,
          amount: value
        }).then(resp=> {
          _this.loading = false;
          onResult(resp, {
            success: data => {
              Message.success("拆分成功");
              _this.myPocketItems = data.data;
            }
          });
        }, resp=> {
          _this.loading = false;
        });
      }, function () {
        //取消
        _this.$message({
          type: 'info',
          message: '取消拆分'
        });
      })
    }
  }
}
